import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Row,
} from 'reactstrap';

import AdminReportsFilterTaxonomy from './FilterTaxonomy';

const AdminReportsFilterTaxonomies = ({
  taxonomies,
  terms,
  addTerm,
  removeTerm,
  clearTerms,
}) => {
  const [lastUpdate, setLastUpdate] = useState(new Date());

  const handleChange = (values, action) => {
    if (action.action === 'select-option') {
      addTerm(action.option);
    }
    if (action.action === 'remove-value') {
      removeTerm(action.removedValue);
    }
    if (action.action === 'clear') {
      clearTerms(parseInt(action.name.replace('taxonomy-', '')));
    }

    setLastUpdate(new Date());
  };

  return (
    <Row className="report-taxonomies-filter-wrapper">
      {taxonomies.map(taxonomy => (
        <AdminReportsFilterTaxonomy
          key={taxonomy.id}
          taxonomy={taxonomy}
          terms={terms}
          lastUpdate={lastUpdate}
          handleChange={handleChange}
        />
      ))}
    </Row>
  );
};

const mapStateToProps = state => ({
  taxonomies: state.Metadata.taxonomies,
});

AdminReportsFilterTaxonomies.propTypes = {
  terms: PropTypes.array.isRequired,
  taxonomies: PropTypes.array.isRequired,
  addTerm: PropTypes.func.isRequired,
  removeTerm: PropTypes.func.isRequired,
  clearTerms: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(AdminReportsFilterTaxonomies);
